module.exports = __webpack_public_path__ + "img/timer-catch.e8277eba.svg";